import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

export default class SignInApis {
  static verifyPhoneNumber = async (mobile_number, user_type) => {
    const url = `${process.env.AE_API_URL}api/v1/auth/mobile_sign_in`;
    const headers = apiHeaders();
    const reqBody = {
      user: {
        mobile_number,
        user_type
      }
    };

    return fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });
  };
}
